<template>
  <ChartLayout :title="title" :units="units" :half="half">
    <DataGetter
      :url="apiRoute"
      :params="params"
      :style="{ position: 'relative' }"
      v-slot="{ data }"
    >
      <DataSlicer
        :data="data"
        x-axis-dimension="category"
        y-axis-dimension="techSector"
        value-dimension="value"
        v-slot="{ slicedData }"
      >
        <Chart
          :options="{
            ...chartOptions,
            series: slicedData.map((series, i) => ({
              ...series,
              colorIndex: i === 0 ? 5 : 1,
              data: series.data
                .map((row) => [...row])
                .sort(
                  (a, b) =>
                    categoryOrder.indexOf(a[0]) - categoryOrder.indexOf(b[0])
                ),
            })),
          }"
        />
      </DataSlicer>
    </DataGetter>
    <template #notes v-if="note">
      <p>{{ note }}</p>
    </template>
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
const stages = ["Early stage", "Later stage"];
const years = [
  "Within 3 years",
  "Within 5 years",
  "Within 10 years",
  "Within 20 years",
];
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    apiRoute: {
      type: String,
      default: "https://api.iea.org",
    },
    countryISO: {
      type: String,
      required: true,
    },
    grouping: {
      type: String,
      required: true,
    },
    indicator: {
      type: String,
      default: "funding",
    },
    unit: {
      type: String,
      default: "Years",
    },
    toExit: {
      type: Boolean,
      default: false,
    },
    half: {
      type: Boolean,
      default: false,
    },
    note: {
      type: String,
      default: null,
    },
  },
  components: {
    Chart,
    ChartLayout,
    DataGetter,
    DataSlicer,
  },
  data() {
    return {
      opposites: {
        Energy: "Non-energy",
        "Energy and digital": "Energy and non-digital",
        "Clean energy": "Non-clean energy",
      },
    };
  },
  computed: {
    units() {
      return this.unit === "Years" ? " years" : "%";
    },
    chartOptions() {
      return ChartOptions.buildOptions(
        {
          xAxis: {
            type: "category",
            className: "highcharts-show-grid",
          },
          yAxis: {
            min: 0,
            className: "highcharts-show-grid",
          },
          tooltip: {
            valueSuffix: this.units,
          },
          plotOptions: {
            spline: {
              marker: {
                enabled: true,
              },
            },
          },
        },
        "spline"
      );
    },
    categoryOrder() {
      return this.toExit ? years : stages;
    },
    params() {
      const { categoryOrder, grouping, opposites, countryISO, unit, toExit } =
        this;
      return {
        indicator: toExit
          ? ["Success of start-ups"]
          : ["Fundings of start-ups"],
        category: categoryOrder,
        techSector: [grouping, opposites[grouping]],
        countryISO: countryISO,
        unit,
      };
    },
  },
};
</script>
